import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TokenBagService } from '../services/token-bag.service';

/**
 * MOB-100 Stage 18 — route guard for authenticated surfaces.
 *
 * The mobile token bag is the source of truth: if at least one entry
 * exists (and one of them is the active tenant), the user is
 * authenticated for routing purposes. The HTTP `authInterceptor`
 * handles per-call token freshness via the refresh queue — guards never
 * try to refresh tokens themselves.
 */
export const authGuard: CanActivateFn = () => {
  const tokenBag = inject(TokenBagService);
  const router = inject(Router);
  if (tokenBag.getActive()) return true;
  return router.createUrlTree(['/auth/landing']);
};
